import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { faCircleMinus, faPen } from '@fortawesome/pro-light-svg-icons';
import { CellClickEvent, GridComponent } from '@progress/kendo-angular-grid';
import { filter } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { UserOperation } from '../../../core/enums/user-operation';
import { UserModel } from '../../../core/models/user/user.model';
import { ShiveRoutes } from '../../../core/routing/segments/route-segments';
import { ShiveDialogService } from '../../../core/services/controls/shive-dialog.service';
import { InvitationHttpService } from '../../../core/state/invitation/invitation-http.service';
import { ShiveGridWrapperComponent } from '../../../shared/components/shive-controls/shive-grid/shive-grid-wrapper.component';
import { InvitationDialogComponent } from '../dialogs/invitation-dialog/invitation-dialog.component';
import { TeamListDataService } from './team-list-data.service';

@Component({
  selector: 'app-team-list',
  templateUrl: './team-list.component.html',
  standalone: false,
})
export class TeamListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('grid') grid: GridComponent;
  @ViewChild('gridWrapperComponent') gridWrapperComponent: ShiveGridWrapperComponent;
  public readonly ShiveRoutes = ShiveRoutes;

  private readonly subs = new SubSink();

  constructor(
    public readonly listTeamDataService: TeamListDataService,
    private readonly router: Router,
    private readonly invitationHttpService: InvitationHttpService,
    private readonly shiveDialogService: ShiveDialogService,
  ) {}

  ngOnInit(): void {
    this.listTeamDataService.loadGridData();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.initContextMenuCallbacks();
  }

  public onCellClick(e: CellClickEvent): void {
    if (e.columnIndex === this.grid.columns.length - 1) {
      return;
    }
    const userModel = e.dataItem as UserModel;
    void this.router.navigate([ShiveRoutes.UserEdit, userModel.id]);
  }

  public openInviteMemberDialog(): void {
    const ref = this.shiveDialogService.open({
      title: 'Mitglied einladen',
      content: InvitationDialogComponent,
      width: 572,
    });

    this.subs.sink = ref.result
      .pipe(filter((dialogResult) => dialogResult !== UserOperation.Cancel))
      .subscribe((email: string) => {
        this.invitationHttpService.createInvitation(email);
      });
  }

  private initContextMenuCallbacks(): void {
    this.gridWrapperComponent.contextMenuItems = [
      {
        text: 'Bearbeiten',
        faIcon: faPen,
        callback: () => {},
        isVisible: () => true,
        isActivated: true,
      },
      {
        text: 'Entfernen',
        faIcon: faCircleMinus,
        callback: () => {},
        isVisible: () => true,
        isActivated: true,
      },
    ];
  }
}
